export default "__VITE_ASSET__D3I9Dk1___";